import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FiltrosRequestService {

  private FILTROS_API = '';

  constructor( private http : HttpClient ) {
    this.FILTROS_API = environment.API_FILTROS;
  }

  public getRequest( request : string, params : any [] ) {

    const URL = `${this.FILTROS_API}/${ request }`;
    const HEADERS = new HttpHeaders ({
      "Content-Type" : "application/json"
    });

    return this.http.post(
      URL,
      {
        "codigoBaseDatos" : params[0],
        "parametrosFiltros" : params[1]
      },
      { headers : HEADERS }
    );

  }

}
